import { ChangeBusinessDetails } from './ChangeBusinessDetails';

export class ChangeReCaptchaGroup extends ChangeBusinessDetails {
  type: string = 'ChangeReCaptchaGroup';
}
